export default __webpack_public_path__ + "static/media/Graphik-Bold.6417b640.otf";